import type { QuoteDispositionKind, QuoteTaskStatus } from "@common/client"
import {
  StatusGlyph,
  type StatusKind,
} from "@/routes/_layout/quotes/-components/status-glyphs"
import { taskStatusLabel } from "../-lib/task-values"

function kindOf(
  status: QuoteTaskStatus,
  disposition?: QuoteDispositionKind,
): StatusKind {
  switch (status) {
    case "draft":
      return "draft"
    case "ready":
      return disposition === "review" ? "in_progress" : "pending"
    case "ready_for_customer":
      return disposition === "customer_review" ? "sent" : "done"
    case "clarification_requested":
      return "waiting"
    case "approved":
      return "verified"
    case "rejected":
      return "failed"
    case "excluded":
      return "skipped"
  }
}

export function TaskStatusIcon({
  status,
  disposition,
}: {
  status: QuoteTaskStatus
  disposition?: QuoteDispositionKind
}): React.ReactElement {
  return (
    <StatusGlyph
      kind={kindOf(status, disposition)}
      label={taskStatusLabel(status, disposition)}
    />
  )
}
